const localhost = window.location.host.includes('localhost') ? 'localhost' : null;
export default localhost;
